/**
 * Generates the column headers based on the active tab (pending/History) and category data.
 *
 * @param {string} tabActive
 * @param {Array} categoryData
 * @returns {Array}
 */
export const getColumnConfig = (tabActive, categoryData) => {
  const historyTab = "3";
  const baseColumns = [
    {
      title: "Title",
      avatar: true,
      filter: "searchTitle",
      width: 412,
    },
    {
      title: "Category",
      filter: "selectCategory",
      dropDown: categoryData?.map((data) => ({
        name: data?.name,
        value: data?.id,
      })),
      width: 173,
      chip: true,
    },
    {
      title: "Author",
      filter: "searchRecipients",
      width: 237,
      avatar: true,
    },
  ];

  const publishedDateColumn = {
    title: "Published date",
    filter: "datePickerAlert",
    width: 204,
  };

  const expiryDateColumn = {
    title: "Expiry date",
    filter: "datePickerExpiry",
    width: 170,
  };

  const scheduledDateColumn = {
    title: "Scheduled date",
    filter: "datePickerScheduled",
    width: 204,
  };

  // Adjust columns based on the active tab
  if (tabActive === historyTab) {
    // For history tab (tabActive === "3"), include Published date, Scheduled date, and Expiry date
    return [
      ...baseColumns,
      publishedDateColumn, // Published date included for history
      expiryDateColumn, // Expiry date included for history
    ];
  } else if (tabActive === "2") {
    // For tabActive === "2", include only Scheduled date and Expiry date
    return [
      ...baseColumns,
      scheduledDateColumn, // Scheduled date for tab 2
      expiryDateColumn, // Expiry date for tab 2
    ];
  } else {
    // For other tabs (default case), include Published date and Expiry date
    return [...baseColumns, expiryDateColumn];
  }
};
